import _default from './MountNode';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/addons/MountNode/index.js
// module id = 268
// module chunks = 0